module.exports = {
          srcSet: __webpack_public_path__ + "public/images/26d8b22c88a9960b82598967965e1895-209.png"+" 209w",
          images:[ {path: __webpack_public_path__ + "public/images/26d8b22c88a9960b82598967965e1895-209.png",width: 209,height: 59}],
          src: __webpack_public_path__ + "public/images/26d8b22c88a9960b82598967965e1895-209.png",
          toString:function(){return __webpack_public_path__ + "public/images/26d8b22c88a9960b82598967965e1895-209.png"},
          
          width: 209,
          height: 59
        }